import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl-next';
import { mentionMessages as messages } from '@atlaskit/editor-common/messages';
import { TOOLBAR_BUTTON, ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import MentionIcon from '@atlaskit/icon/glyph/editor/mention';
var ToolbarMention = /*#__PURE__*/function (_PureComponent) {
  _inherits(ToolbarMention, _PureComponent);
  var _super = _createSuper(ToolbarMention);
  function ToolbarMention() {
    var _this;
    _classCallCheck(this, ToolbarMention);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleInsertMention", function () {
      if (!_this.props.editorView) {
        return false;
      }
      _this.props.onInsertMention();
      return true;
    });
    return _this;
  }
  _createClass(ToolbarMention, [{
    key: "render",
    value: function render() {
      var mentionStringTranslated = this.props.intl.formatMessage(messages.mentionsIconLabel);
      return /*#__PURE__*/React.createElement(ToolbarButton, {
        testId: this.props.testId,
        buttonId: TOOLBAR_BUTTON.MENTION,
        spacing: "none",
        onClick: this.handleInsertMention,
        disabled: this.props.isDisabled,
        title: mentionStringTranslated + '@',
        iconBefore: /*#__PURE__*/React.createElement(MentionIcon, {
          label: mentionStringTranslated
        })
      });
    }
  }]);
  return ToolbarMention;
}(PureComponent);
export default injectIntl(ToolbarMention);